import { SummaryHeaderProps } from '../SummaryList.types'
import { HeaderItem, HeaderWrapper } from './SummaryHeader.styles'

const SummaryHeader = (props: SummaryHeaderProps) => {
  const { headers } = props
  return (
    <HeaderWrapper className="SummaryHeaderWrapper">
      {headers?.map((header: string, index: number) => {
        return (
          <HeaderItem className={`SummaryHeader-${index}`}>{header}</HeaderItem>
        )
      })}
    </HeaderWrapper>
  )
}

export default SummaryHeader
